<script setup>
definePageMeta({
  theme: 'theme-default'
})

const route = useRoute()
const slug = computed(() => route.params.slug)
const { $bitterBrainsApi } = useNuxtApp()
const { formatDate } = useHelpers()

const { data } = await useAsyncData(
    `article/${slug}`,
    () => $bitterBrainsApi.get(`/articles/${slug.value}`, {
      others: 3
    }),
    {
      watch: [slug]
    }
)

const article = computed(() => data.value.data)
const otherArticles = computed(() => data.value.others)
</script>

<template>
  <div
    id="top"
    class="pb-25 pt-10 xl:pt-20">
    <AppContainer>
      <div
        class="mx-auto my-20 max-w-screen-article font-montserrat">
        <div class="mb-10 flex items-center justify-center">
          <img :src="article.thumbnail">
        </div>
        <h3 class="px-2 text-4xl font-bold uppercase text-white shadow">
          {{ article.title }}
        </h3>
        <div class="my-4 flex items-center justify-between">
          <div class="flex items-center space-x-4">
            <img
              :src="article.author.avatar"
              alt="avatar"
              class="size-10 rounded-full">
            <span>{{ article.author.name }}</span>
          </div>
          <div class="flex space-x-3 py-4">
            <BaseIcon
              name="calendar"
              class="size-5" />
            <span>{{ formatDate(article.published_at) }}</span>
          </div>
        </div>
        <div
          class="prose mt-10 w-full max-w-none overflow-hidden text-base text-white xl:prose-xl dark:prose-invert prose-a:text-sky-500 prose-a:no-underline prose-pre:overflow-auto"
          v-html="article.body_html" />
      </div>
      <div v-if="otherArticles.length > 0">
        <BaseTitle>More Articles</BaseTitle>
        <div class="my-20 grid gap-6 px-2 sm:grid-cols-2 sm:p-0 lg:grid-cols-3">
          <ArticleCard
            v-for="otherArticle in otherArticles"
            :article="otherArticle"
            target="_blank" />
        </div>
        <div class="flex items-center justify-center">
          <BaseBtn
            tag="a"
            href="/blog"
            target="_blank">
            View all
          </BaseBtn>
        </div>
      </div>
    </AppContainer>
    <HomeContact />
  </div>
</template>

<style scoped lang="css">

</style>
